import locale from "@bonliva-crm/locale";

export function useLocale() {
  return { locale };
}
